import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const termSections = [
  {
    id: "definisi",
    title: "1. Definisi",
    items: [
      "Bank atau Kami: PT Bank Syariah Indonesia Tbk, terdaftar dan diawasi oleh OJK.",
      "Aplikasi BWarga: Platform seluler untuk manajemen hunian, pembayaran iuran lingkungan, dan komunikasi warga.",
      "Pengguna atau Anda: Perorangan terdaftar sebagai penghuni/warga di perumahan yang bekerja sama dengan Bank.",
      "Pengurus Lingkungan: Pihak pengelola perumahan (RT/RW/Badan Pengelola) dengan wewenang mengatur data warga.",
      "Tagihan: Kewajiban pembayaran rutin (IPL, Keamanan, Sampah) atau insidental yang diterbitkan Pengurus.",
      "Emergency Button: Fitur tombol darurat untuk mengirim sinyal bahaya dan lokasi ke petugas keamanan setempat.",
    ],
  },
  {
    id: "akun",
    title: "2. Kelayakan dan Pendaftaran Akun",
    items: [
      "Kelayakan: Pengguna harus merupakan penghuni sah (pemilik atau penyewa) di perumahan yang terdaftar di ekosistem BWarga.",
      "Verifikasi: Data akun (Nama, Alamat Blok/No Rumah, NIK) harus sesuai data yang tercatat pada Pengurus Lingkungan.",
      "Keamanan Akun: Anda bertanggung jawab penuh menjaga kerahasiaan password, PIN, atau OTP yang dikirim ke email Anda.",
      "Satu Perangkat: Demi keamanan, satu akun Warga disarankan hanya aktif di satu perangkat utama.",
    ],
    note: "Bank tidak bertanggung jawab atas kerugian akibat kelalaian Anda menjaga kerahasiaan akun.",
  },
  {
    id: "pembayaran",
    title: "3. Layanan Pembayaran dan Keuangan",
    items: [
      "Kanal Pembayaran: Terintegrasi dengan BSI Mobile, ATM BSI, dan Cabang melalui Virtual Account (VA).",
      "Kewajiban Pembayaran: Anda setuju membayar Tagihan sesuai nominal yang tertera sebelum tanggal jatuh tempo.",
      "Biaya Admin: Mungkin dikenakan biaya administrasi sesuai kebijakan Bank, tertera jelas di halaman konfirmasi.",
      "Status Pembayaran: Status berubah 'Lunas' otomatis setelah konfirmasi dana masuk diterima sistem Bank.",
      "Dana Iuran: Bank hanya sebagai penyedia kanal pembayaran. Sengketa penggunaan dana adalah urusan Warga dan Pengurus.",
    ],
  },
  {
    id: "emergency",
    title: "4. Penggunaan Fitur Darurat (Emergency Button)",
    items: [
      "Tujuan: Hanya boleh digunakan dalam keadaan darurat yang mengancam keselamatan jiwa, properti, atau medis mendesak.",
      "Akses Lokasi: Aplikasi akan mengirimkan koordinat GPS Anda kepada Petugas Keamanan dan Pengurus saat tombol ditekan.",
      "Penyalahgunaan: Dilarang keras untuk tujuan iseng/prank. Dapat mengakibatkan pemblokiran akun dan sanksi dari Pengurus.",
      "Batasan Tanggung Jawab: Bank tidak menjamin kecepatan respons fisik atau ketersediaan Petugas Keamanan setempat.",
    ],
    warning:
      "Penyalahgunaan Emergency Button dapat mengakibatkan pemblokiran akun secara permanen.",
  },
  {
    id: "conduct",
    title: "5. Tata Tertib Penggunaan (User Conduct)",
    intro: "Dalam menggunakan Aplikasi, Anda dilarang untuk:",
    items: [
      "Mengunggah konten yang mengandung unsur SARA, pornografi, ancaman, atau pencemaran nama baik.",
      "Melakukan tindakan yang merusak, melumpuhkan, atau mengganggu server dan jaringan Aplikasi.",
      "Mencoba mengakses fitur Admin atau data pribadi warga lain tanpa izin (hacking).",
      "Menggunakan Aplikasi untuk tujuan penipuan atau pencucian uang.",
    ],
  },
  {
    id: "hki",
    title: "6. Hak Kekayaan Intelektual",
    text: "Seluruh desain, logo, kode sumber, dan konten dalam Aplikasi BWarga adalah hak milik PT Bank Syariah Indonesia Tbk atau pemberi lisensinya. Anda tidak diperkenankan menyalin, memodifikasi, atau mendistribusikan ulang bagian manapun tanpa izin tertulis dari Bank.",
  },
  {
    id: "disclaimer",
    title: "7. Pembatasan Tanggung Jawab",
    intro:
      'Aplikasi disediakan "sebagaimana adanya" (as is). Bank tidak bertanggung jawab atas:',
    items: [
      "Sengketa antar warga atau antara warga dengan pengurus.",
      "Kesalahan input nominal pembayaran yang dilakukan oleh Pengguna.",
      "Gangguan layanan akibat kegagalan jaringan internet, telekomunikasi, atau Force Majeure.",
    ],
  },
  {
    id: "hukum",
    title: "8. Hukum yang Berlaku dan Penyelesaian Sengketa",
    text: "Syarat dan Ketentuan ini tunduk pada hukum Negara Republik Indonesia. Perselisihan diselesaikan secara musyawarah untuk mufakat. Jika tidak tercapai kesepakatan, diselesaikan melalui Pengadilan Negeri di wilayah hukum Kantor Pusat Bank Syariah Indonesia.",
  },
];

const biometricAndroid = [
  "Anda memberikan izin kepada BWarga untuk menggunakan fitur keamanan biometrik perangkat sebagai metode verifikasi pengganti password.",
  "Setiap sidik jari yang terdaftar pada perangkat ini akan dianggap sebagai akses yang sah.",
  "BWarga tidak menyimpan data sidik jari Anda. Proses verifikasi dilakukan sepenuhnya oleh sistem operasi perangkat.",
  "BWarga dan BSI tidak bertanggung jawab atas penyalahgunaan akses jika perangkat digunakan orang lain yang biometriknya terdaftar.",
  "Jika verifikasi biometrik gagal, Anda tetap bisa menggunakan password manual.",
  "Fitur dapat dinonaktifkan kapan saja melalui menu Profil.",
];

const biometricIOS = [
  "Anda memberikan izin kepada BWarga untuk menggunakan Face ID sebagai metode verifikasi pengganti password.",
  "Setiap wajah yang terdaftar pada perangkat ini akan dianggap sebagai akses yang sah.",
  "BWarga tidak menyimpan data wajah Anda. Proses verifikasi dilakukan sepenuhnya oleh sistem operasi perangkat.",
  "BWarga dan BSI tidak bertanggung jawab atas penyalahgunaan akses jika perangkat digunakan orang lain yang Face ID-nya terdaftar.",
  "Jika verifikasi Face ID gagal, Anda tetap bisa menggunakan password manual.",
  "Fitur dapat dinonaktifkan kapan saja melalui menu Profil.",
];

export default function TermsConditions() {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("definisi");
  const [activeTab, setActiveTab] = useState("syarat");
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    document
      .getElementById(id)
      ?.scrollIntoView({ behavior: "smooth", block: "start" });
    setActiveSection(id);
  };

  return (
    <div className="min-h-screen bg-slate-50 font-sans">
      {/* Top bar */}
      <div
        className={`sticky top-0 z-50 transition-all duration-300 ${
          scrolled ? "bg-white/90 backdrop-blur-md shadow-sm" : "bg-white"
        } border-b border-slate-200`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <button
            onClick={() => {
              const saved = sessionStorage.getItem("scrollPosition");
              navigate(-1);
              if (saved) {
                setTimeout(() => {
                  window.scrollTo({
                    top: parseInt(saved),
                    behavior: "instant",
                  });
                }, 50);
              }
            }}
            className="flex items-center gap-2 text-slate-500 hover:text-slate-900 transition-colors text-sm font-medium"
          >
            <svg
              className="w-4 h-4"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-7-7 7-7"
              />
            </svg>
            Kembali
          </button>
          <span className="text-sm text-slate-400 font-medium tracking-wide uppercase">
            Syarat & Ketentuan
          </span>
          <div className="w-16" />
        </div>
      </div>

      {/* Hero */}
      <div className="bg-gradient-to-br from-indigo-700 via-indigo-600 to-blue-500 text-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 rounded-xl bg-white/20 flex items-center justify-center">
              <svg
                className="w-5 h-5 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                />
              </svg>
            </div>
            <span className="text-indigo-200 text-sm font-semibold tracking-widest uppercase">
              BWarga × BSI
            </span>
          </div>
          <h1 className="text-3xl md:text-4xl font-bold mb-3 tracking-tight">
            Syarat & Ketentuan
          </h1>
          <p className="text-indigo-100 text-base md:text-lg max-w-2xl leading-relaxed">
            Mohon membaca Syarat dan Ketentuan ini dengan saksama sebelum
            mengunduh, mengakses, atau menggunakan Aplikasi BWarga.
          </p>
          <p className="mt-4 text-indigo-200 text-sm">
            Berlaku sejak: 1 Januari 2025
          </p>
        </div>
      </div>

      {/* Tab switcher */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        <div className="inline-flex bg-white border border-slate-200 rounded-xl p-1 shadow-sm">
          {[
            { key: "syarat", label: "Syarat & Ketentuan Aplikasi" },
            { key: "biometrik", label: "Aktivasi Login Biometrik" },
          ].map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
                activeTab === tab.key
                  ? "bg-indigo-600 text-white shadow-sm"
                  : "text-slate-600 hover:text-slate-900"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {activeTab === "syarat" ? (
          <div className="flex gap-8 items-start">
            {/* Sidebar */}
            <aside className="hidden lg:block w-64 shrink-0 sticky top-24">
              <div className="bg-white rounded-2xl border border-slate-200 p-4 shadow-sm">
                <p className="text-xs font-bold text-slate-400 uppercase tracking-widest mb-3 px-2">
                  Daftar Isi
                </p>
                <nav className="space-y-1">
                  {termSections.map((s) => (
                    <button
                      key={s.id}
                      onClick={() => scrollTo(s.id)}
                      className={`w-full text-left text-sm px-3 py-2 rounded-lg transition-all duration-150 ${
                        activeSection === s.id
                          ? "bg-indigo-50 text-indigo-700 font-semibold"
                          : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                      }`}
                    >
                      {s.title}
                    </button>
                  ))}
                  <button
                    onClick={() => scrollTo("kontak")}
                    className={`w-full text-left text-sm px-3 py-2 rounded-lg transition-all duration-150 ${
                      activeSection === "kontak"
                        ? "bg-indigo-50 text-indigo-700 font-semibold"
                        : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                    }`}
                  >
                    9. Kontak Kami
                  </button>
                </nav>
              </div>
            </aside>

            {/* Main */}
            <main className="flex-1 min-w-0 space-y-6">
              {/* Preamble */}
              <div className="bg-amber-50 border border-amber-200 rounded-2xl p-5 flex items-start gap-3">
                <svg
                  className="w-5 h-5 text-amber-500 mt-0.5 shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
                <p className="text-sm text-amber-800">
                  <span className="font-semibold">Penting:</span> Dengan
                  menggunakan Aplikasi BWarga, Anda dianggap telah membaca,
                  memahami, dan menyetujui seluruh isi Syarat dan Ketentuan ini.
                </p>
              </div>

              {termSections.map((section) => (
                <section
                  key={section.id}
                  id={section.id}
                  className="bg-white rounded-2xl border border-slate-200 p-6 md:p-8 shadow-sm scroll-mt-24"
                  onMouseEnter={() => setActiveSection(section.id)}
                >
                  <h2 className="text-lg font-bold text-slate-900 mb-5 pb-3 border-b border-slate-100">
                    {section.title}
                  </h2>

                  {section.intro && (
                    <p className="text-sm text-slate-600 mb-3">
                      {section.intro}
                    </p>
                  )}

                  {section.items && (
                    <ul className="space-y-2">
                      {section.items.map((item, ii) => (
                        <li
                          key={ii}
                          className="flex items-start gap-2.5 text-sm text-slate-600"
                        >
                          <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-indigo-400 shrink-0" />
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}

                  {section.text && (
                    <p className="text-sm text-slate-600 leading-relaxed">
                      {section.text}
                    </p>
                  )}

                  {section.note && (
                    <div className="mt-4 bg-indigo-50 border border-indigo-100 rounded-xl p-3.5 text-sm text-indigo-800 flex items-start gap-2">
                      <svg
                        className="w-4 h-4 mt-0.5 shrink-0 text-indigo-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      {section.note}
                    </div>
                  )}

                  {section.warning && (
                    <div className="mt-4 bg-red-50 border border-red-100 rounded-xl p-3.5 text-sm text-red-700 flex items-start gap-2">
                      <svg
                        className="w-4 h-4 mt-0.5 shrink-0 text-red-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                        />
                      </svg>
                      {section.warning}
                    </div>
                  )}
                </section>
              ))}

              {/* Contact */}
              <section
                id="kontak"
                className="bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 md:p-8 text-white shadow-sm scroll-mt-24"
                onMouseEnter={() => setActiveSection("kontak")}
              >
                <h2 className="text-lg font-bold mb-5 pb-3 border-b border-white/10">
                  9. Kontak Kami
                </h2>
                <p className="text-slate-300 text-sm mb-5">
                  Jika Anda mengalami kendala teknis atau memiliki pertanyaan
                  terkait Aplikasi BWarga:
                </p>
                <div className="grid sm:grid-cols-2 gap-3">
                  {[
                    {
                      icon: "🏢",
                      label: "Kantor Pusat",
                      value:
                        "Gedung The Tower, Jl. Gatot Subroto No. 27, Jakarta Selatan 12930",
                    },
                    { icon: "📞", label: "BSI Call", value: "14040" },
                    {
                      icon: "💬",
                      label: "WhatsApp Resmi",
                      value: "0815-8411-4040",
                    },
                    {
                      icon: "✉️",
                      label: "Email",
                      value: "contactus@bankbsi.co.id",
                    },
                  ].map((c) => (
                    <div key={c.label} className="bg-white/10 rounded-xl p-4">
                      <div className="flex items-center gap-2 mb-1">
                        <span className="text-base">{c.icon}</span>
                        <span className="text-xs text-slate-400 font-medium uppercase tracking-wide">
                          {c.label}
                        </span>
                      </div>
                      <p className="text-sm text-white font-medium">
                        {c.value}
                      </p>
                    </div>
                  ))}
                </div>
                <p className="text-slate-400 text-xs mt-4">
                  Bantuan Aplikasi juga tersedia melalui menu{" "}
                  <span className="text-white">"Bantuan"</span> pada halaman
                  Profil Aplikasi.
                </p>
              </section>

              <p className="text-center text-xs text-slate-400 pb-4">
                © 2025 PT Bank Syariah Indonesia Tbk. Semua hak dilindungi.
              </p>
            </main>
          </div>
        ) : (
          /* Biometric tab */
          <div className="max-w-3xl mx-auto space-y-6">
            {/* Android */}
            <div className="bg-white rounded-2xl border border-slate-200 p-6 md:p-8 shadow-sm">
              <div className="flex items-center gap-3 mb-5 pb-4 border-b border-slate-100">
                <div className="w-9 h-9 rounded-xl bg-green-100 flex items-center justify-center text-lg">
                  🤖
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-900">
                    Login Biometrik — Android
                  </h2>
                  <p className="text-xs text-slate-500">
                    Sidik Jari (Fingerprint)
                  </p>
                </div>
              </div>
              <p className="text-sm text-slate-600 mb-4">
                Dengan mengaktifkan fitur Login Biometrik Sidik Jari ini, Anda
                menyetujui ketentuan berikut:
              </p>
              <ul className="space-y-3">
                {biometricAndroid.map((item, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 text-sm text-slate-600"
                  >
                    <span className="w-5 h-5 rounded-full bg-green-100 text-green-700 text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">
                      {i + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            {/* iOS */}
            <div className="bg-white rounded-2xl border border-slate-200 p-6 md:p-8 shadow-sm">
              <div className="flex items-center gap-3 mb-5 pb-4 border-b border-slate-100">
                <div className="w-9 h-9 rounded-xl bg-slate-100 flex items-center justify-center text-lg">
                  🍎
                </div>
                <div>
                  <h2 className="text-base font-bold text-slate-900">
                    Login Biometrik — iOS
                  </h2>
                  <p className="text-xs text-slate-500">Face ID</p>
                </div>
              </div>
              <p className="text-sm text-slate-600 mb-4">
                Dengan mengaktifkan fitur Login Biometrik Face ID ini, Anda
                menyetujui ketentuan berikut:
              </p>
              <ul className="space-y-3">
                {biometricIOS.map((item, i) => (
                  <li
                    key={i}
                    className="flex items-start gap-3 text-sm text-slate-600"
                  >
                    <span className="w-5 h-5 rounded-full bg-slate-100 text-slate-600 text-xs font-bold flex items-center justify-center shrink-0 mt-0.5">
                      {i + 1}
                    </span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="bg-indigo-50 border border-indigo-100 rounded-2xl p-5 text-sm text-indigo-800">
              <p className="font-semibold mb-1">Catatan Keamanan</p>
              <p>
                BWarga tidak menyimpan data biometrik Anda dalam bentuk apapun.
                Seluruh proses autentikasi dilakukan oleh sistem operasi
                perangkat Anda secara lokal. Aplikasi hanya menerima status
                validasi (Sukses/Gagal).
              </p>
            </div>

            <p className="text-center text-xs text-slate-400 pb-4">
              © 2025 PT Bank Syariah Indonesia Tbk. Semua hak dilindungi.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
